<template>
	<ParentComponent side="right" divId="div3" selectContentClass="selectContent2" />
</template>

<script setup>
	import ParentComponent from "@/components/compoents_base/ParentComponent.vue";
</script>
